import { graphql } from "@/gql";

export const clientsQuery = graphql(`
  query Clients {
    clients {
      nodes {
        ...ClientsPageClient
        status # in order for the sort function to accept these nodes
      }
    }
  }
`);

export const clientTimelineQuery = graphql(`
  query ClientTimeline($id: ID!) {
    client(id: $id) {
      id
      email
      profile {
        id
        fullName
        mobileNumber
        avatarUrl
      }
      trackingStatus
      events(order: DESC) {
        nodes {
          ...TimelineEntry
        }
      }
    }
  }
`);
